import { defineMessage } from 'services/localization';

export const messages = {
    endStepBubbleText: defineMessage('authorise_in_cin_core'),
    endStepDescription: defineMessage('approved_pluraltemplate__authorised_in_cin_core'),
};
